import { createContext, useContext, useState } from "react";

interface AdminAuthContextValue {
  isAdminAuthenticated: boolean;
  setAdminAuthenticated: (value: boolean) => void;
}

const AdminAuthContext = createContext<AdminAuthContextValue>({
  isAdminAuthenticated: false,
  setAdminAuthenticated: () => {},
});

export function AdminAuthProvider({ children }: { children: React.ReactNode }) {
  // Seed from sessionStorage so in-session navigations (where adminUser is
  // already written) don't produce a flash of hidden nav.
  const [isAdminAuthenticated, setAdminAuthenticated] = useState(
    () => !!sessionStorage.getItem("adminUser")
  );

  return (
    <AdminAuthContext.Provider value={{ isAdminAuthenticated, setAdminAuthenticated }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
